// extracted by mini-css-extract-plugin
export default {"button":"ButtonIcon_button__K0QxH"};